import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
@Component({
  selector: 'app-updated-result',
  templateUrl: './updated-result.component.html',
  styleUrls: ['./updated-result.component.scss']
})
export class UpdatedResultComponent implements OnInit {
  updatedResult: FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;
  SessionNo: any;
  constructor(public umsService: UmsService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.updatedResult = this.fb.group({
      list: new FormControl(),
      list2: new FormControl(),
      list3: new FormControl(),
      Debar: new FormControl(),
      Chng: new FormControl(),
      Batch: new FormControl(),
      Exam: new FormControl(),
      WH: new FormControl(),
      SetRem: new FormControl(),
      Sub: new FormControl(),
      Sub1: new FormControl(),
      RegnNo: new FormControl(),
      Marks: new FormControl(),
      Marks2 : new FormControl(),
      Grade:new FormControl(),
      Status: new FormControl(),
      Comment:new FormControl(),
      Valid: new FormControl(),
      Valid1: new FormControl(),

    })
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  fetchList() {
    let payload = {}
    payload["SnNo"] = this.SessionNo;
    payload["InCode"] = 7;
    payload["OpId"] = sessionStorage.getItem('userId');
    this.umsService.fetchRegiList(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMarks = res.data;
        this.filteredListOfMarks = this.ListOfMarks.slice();
      }
      else {

      }

    });

  }
}
